<template>
  <div class="modal-vue rfp-mctb-commerceConnector -expanded">
    <div class="rfp-mctb-commerceConnector__overlay" @click="closeModal"></div>
    <div
      ref="popup"
      class="modal-vue--content"
      :class="[
        {
          'rfp-mctb-commerceConnector__layout-top': popupDirection === 'top',
          'rfp-mctb-commerceConnector__layout-bottom': popupDirection === 'bottom',
          'rfp-mctb-commerceConnector__layout-left': popupDirection === 'left',
          'rfp-mctb-commerceConnector__layout-right': popupDirection === 'right',
        },
      ]"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      aria-labelledby="modal-heading"
    >
      <div
        class="modal-vue--content-panel"
        :class="[
          {
            'rfp-mctb-commerceConnector__wrapper-top-bottom':
              popupDirection === 'top' || popupDirection === 'bottom',
            'rfp-mctb-commerceConnector__wrapper':
              popupDirection === 'right' || popupDirection === 'left',
          },
        ]"
      >
        <span
          role="button"
          tabindex="0"
          class="rfp-mctb-commerceConnector__close rfp-mctb-commerceConnector__tabIndex"
          :aria-label="a11y.closeButtonAriaLabel"
          @keydown.space.prevent="closeModal"
          @keydown.enter="closeModal"
          @click="closeModal"
        >
          X
        </span>

        <div
          v-if="commerceData.Product.Retailers.length === 0"
          class="rfp-mctb-commerceConnector__description"
          style="height: 100%"
        >
          <span
            id=""
            style="font-size: 2em; margin-block: 0.67em; margin-inline: 0; font-weight: bold"
          >
            <strong class="rfp-mctb__005__header">{{ retailerUnavailable }}</strong>
          </span>
        </div>
        <fieldset v-else class="vue-tabs" role="presentation">
          <legend class="rfp-mctb-commerceConnector__description" role="presentation">
            <h1 id="modal-heading">
              <strong v-if="commerceData.Product.BrandTitle != ''" class="rfp-mctb__001__header"
                >{{ commerceData.Product.BrandTitle }} -
              </strong>
              <strong v-if="commerceData.Product.SubBrandTitle != ''" class="rfp-mctb__002__header"
                >{{ commerceData.Product.SubBrandTitle }} -
              </strong>
              <strong v-if="commerceData.Product.Title != ''" class="rfp-mctb__003__header"
                >{{ commerceData.Product.Title }} -
              </strong>
              <strong class="rfp-mctb__004__header"> {{ headerText }} </strong>
            </h1>
          </legend>

          <div v-if="showTabs" class="_rfp_mctb_list_006_ nav-tabs-navigation">
            <div class="_rfp_mctb_list_007_ nav-tabs-wrapper">
              <ul role="tablist" class="_rfp_mctb_list_008_ nav nav-tabs">
                <li
                  v-for="(country, index) in countriesWithRetailers"
                  :id="country.DisplayName"
                  :key="country.DisplayName"
                  :ref="`tab-${index}`"
                  role="tab"
                  :tabindex="index === activeTabIndex ? 0 : -1"
                  :aria-selected="index === activeTabIndex"
                  aria-controls="rfp-mctb-retailer-tabpanel"
                  class="_rfp_mctb_list_009_ tab active"
                  :class="{ active__tab: index === activeTabIndex }"
                  @keydown.right="handleKeydown(activeTabIndex + 1)"
                  @keydown.left="handleKeydown(activeTabIndex - 1)"
                  @click="setActiveTab(index)"
                >
                  <span class="_rfp_mctb_list_0010_ active_tab tabs__link">
                    <span class="_rfp_mctb_list_0011_ title title_center">
                      {{ country.DisplayName }}
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <section
            id="rfp-mctb-retailer-tabpanel"
            :role="showTabs ? 'tabpanel' : null"
            class="_rfp_mctb_list_0018_ tab-container"
          >
            <ul
              :class="{
                'rfp-mctb-commerceConnector__shops':
                  popupDirection === 'right' || popupDirection === 'left',
                'rfp-mctb-commerceConnector__shops__top__bottom':
                  popupDirection === 'top' || popupDirection === 'bottom',
              }"
            >
              <li
                v-for="retailer in computedRetailers"
                :key="retailer.RetailerItemId"
                class="rfp-mctb-commerceConnector__item"
              >
                <a
                  :href="retailer.RetailerUrl"
                  class="rfp-mctb-commerceConnector__item-link"
                  @click.prevent="
                    pageRedirectUrl(
                      retailer.RetailerUrl,
                      retailer.OpenInNewWindow,
                      retailer.RetailerTags,
                      retailer.RetailerTagsGS,
                      retailer.Name,
                    )
                  "
                >
                  <input
                    class="isSrOnly rfp-mctb-commerceConnector__radioButton rfp-mctb-commerceConnector__tabIndex"
                    type="radio"
                    name="retailer"
                    :value="retailer.Name"
                    tabindex="-1"
                    inert
                  />
                  <label role="presentation" class="rfp-mctb-commerceConnector__radioLabel">
                    <img class="rfp-mctb-commerceConnector__logo" :src="retailer.Logo" alt="" />
                    <span
                      class="rfp-mctb-commerceConnector-retailer-desc"
                      v-html="retailer.Description"
                    ></span>
                  </label>
                </a>
              </li>
            </ul>
          </section>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import ServiceType from '../rfp-mctb-tags/tagging-service-type';

export default {
  name: 'rfp-mctb-pop-up-action-mode',
  props: {
    initialData: {
      type: Object,
      required: true,
    },
    popupDirection: {
      type: String,
      default: 'left',
    },
    componentDiffs: {
      type: Boolean,
      required: true,
    },
    headerText: {
      type: String,
      default: 'Carousel Header',
    },
    retailerUnavailable: {
      type: String,
      required: true,
    },
    productname: {
      type: String,
      required: true,
    },
    productids: {
      type: String,
      required: true,
    },
    initialExtraParams: {
      type: Object,
      required: false,
    },
    a11y: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      shopData: {},
      commerceData: this.initialData,
      expandPanel: false,
      buyMessage: 'Buynow',
      taggingAction: '',
      taggingLabel: '',
      baseredirectURL: '',
      baseOpenInNewWindow: '',
      basetagDatas: {},
      basetagDatasGS: {},
      eventProjectDataLayer: {},
      activeTabIndex: 0,
      areaValue: true,
      extraParams: this.initialExtraParams,
      retailerCount: 0,
    };
  },
  computed: {
    countriesWithRetailers() {
      return this.commerceData.CountryList.filter((item) => {
        return item.Name in this.retailersByCountryName;
      });
    },
    activeTabCountry() {
      return this.countriesWithRetailers[this.activeTabIndex];
    },
    retailersByCountryName() {
      return this.commerceData.Product.Retailers.reduce((acc, item) => {
        acc[item.Country] ||= [];
        acc[item.Country].push(item);
        return acc;
      }, {});
    },
    activeCountryTabRetailers() {
      return this.retailersByCountryName[this.activeTabCountry?.Name] || [];
    },
    computedRetailers() {
      if (this.countriesWithRetailers.length > 0) {
        return this.activeCountryTabRetailers;
      }
      return this.commerceData.Product.Retailers || [];
    },
    showTabs() {
      return this.commerceData.CountryList.length > 1;
    },
  },
  created() {
    eventBus.on('rfp-mctb-optional-popup-enable', () => {
      this.expandPanel = true;
    });
    eventBus.on('rfp-mctb-datalayer-event', (val) => {
      this.eventProjectDataLayer = val;
    });
    eventBus.on('rfp-mctb-extra-param-component', (val) => {
      this.extraParams = val;
    });
    eventBus.emit('rfp-mctb-extra-param-component1');
  },
  methods: {
    pageRedirectUrl(
      redirectURL,
      OpenInNewWindow,
      standardTagsString,
      gsTagsString,
      pageRedirectUrls,
    ) {
      this.buyMessage = pageRedirectUrls;
      this.baseredirectURL = redirectURL;
      this.baseOpenInNewWindow = OpenInNewWindow;
      if (standardTagsString) {
        eventBus.emit('rfp-mctb-datalayer-event-new');
        let tags = {};

        try {
          tags = JSON.parse(standardTagsString);
        } catch (e) {
          console.error(
            'error/rfp-mctb-pop-up-action-mode#pageRedirectUrl: Standard (GA) tag parsing failed',
            e,
          );
        }

        if (this.componentDiffs && Object.keys(this.eventProjectDataLayer).length > 0) {
          for (var propName in this.eventProjectDataLayer) {
            tags[propName] = this.eventProjectDataLayer[propName];
          }
        }

        this.basetagDatas = tags;
      }
      if (gsTagsString) {
        try {
          this.basetagDatasGS = JSON.parse(gsTagsString);
        } catch (e) {
          console.error(
            'error/rfp-mctb-pop-up-action-mode#pageRedirectUrl: GRIDSUM tag parsing failed',
            e,
          );
        }
      }

      this.buyNowRetailers();
    },
    closeModal() {
      eventBus.emit('rfp-optional-popup-close');
    },
    buyNowRetailers() {
      eventBus.emit('rfpTaggingFoundation', {
        data: window.dataLayer ? this.basetagDatas : this.basetagDatasGS,
        values: {
          productName: this.productname,
          productId: this.productids,
          retailerName: this.buyMessage,
        },
        extraParams: this.extraParams,
        service: window.dataLayer ? ServiceType.GA : ServiceType.GSQ,
      });
      const target = this.baseOpenInNewWindow === true ? '_blank' : '_self';
      window.open(this.baseredirectURL, target);
    },
    handleKeydown(index) {
      if (index < 0 || index >= this.countriesWithRetailers.length) return;

      this.setActiveTab(index);

      this.$refs[`tab-${index}`][0].focus();
    },
    setActiveTab(index) {
      this.activeTabIndex = index;
    },
  },
};
</script>
